import axios from "axios";
import { getContext } from "../utils/sessionStorage";
import { getViewAsHeaders } from "../utils/viewAsProfile";

interface apiConsumerInterface {
  endpoint: string;
  method: "GET" | "POST" | "DELETE" | "PUT" | "PATCH";
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body?: any;
  headers?: Record<string, string>;
  timeout?: number;
}

export const apiConsumer = ({
  endpoint,
  method,
  body,
  headers,
  timeout,
}: apiConsumerInterface) => {
  const context = getContext();
  const token = context?.user?.token;
  return axios({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    url: endpoint,
    method,
    data: body,
    timeout,
    headers: {
      ...headers,
      // YOS-9865: the superadmin's view mode, so the API does not hide the concession being simulated
      ...getViewAsHeaders(endpoint),
      ...(token && { Authorization: `Bearer ${token}` }),
      [`${process.env.REACT_APP_HEADER1}`]: "web",
      [`${process.env.REACT_APP_HEADER2}`]: "yoshi-dashboard",
      [`${process.env.REACT_APP_HEADER3}`]: `1`,
    },
  });
};
